/*
 * Dismissible announcement bar.
 *
 * The dismissal is per session, not permanent — a returning visitor should see
 * the offer again. In the theme editor it never hides, otherwise the merchant
 * dismisses it once and cannot find the section again.
 *
 * Wrapped in an IIFE because a second instance of this section on one
 * template loads this file with its own <script src>, so the browser
 * executes it twice; without the wrapper the second execution throws on the
 * repeated top-level `class` declaration before the customElements.get()
 * guard below ever runs.
 */
(function () {
class CdAnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.key = this.dataset.key;
    this.inEditor = Boolean(window.Shopify && window.Shopify.designMode);

    if (!this.inEditor && this.isDismissed()) {
      this.hidden = true;
      return;
    }

    const close = this.querySelector('.cd-announce__close');
    if (close) {
      close.addEventListener('click', () => this.dismiss());
    }
  }

  isDismissed() {
    try {
      return sessionStorage.getItem(this.key) === '1';
    } catch (e) {
      // Private mode or storage disabled — just show the bar.
      return false;
    }
  }

  dismiss() {
    this.hidden = true;
    try {
      sessionStorage.setItem(this.key, '1');
    } catch (e) {
      // Nothing to do; the bar stays dismissed for this page view only.
    }
  }
}

if (!customElements.get('cd-announcement-bar')) {
  customElements.define('cd-announcement-bar', CdAnnouncementBar);
}
})();
